// Etiquetas compartidas del módulo Comunicaciones.

export const ESTADOS = {
  borrador: { label: 'Borrador', color: 'default' },
  encolada: { label: 'Preparando', color: 'processing' },
  enviando: { label: 'Enviando', color: 'processing' },
  enviada: { label: 'Enviada', color: 'success' },
  fallida: { label: 'Fallida', color: 'error' },
  cancelada: { label: 'Detenida', color: 'warning' },
};

export const ESTADOS_ENTREGA = {
  pendiente: { label: 'En cola', color: 'default' },
  enviando: { label: 'Saliendo', color: 'processing' },
  enviado: { label: 'Entregado', color: 'success' },
  fallido: { label: 'No entregado', color: 'error' },
  omitido: { label: 'Omitido', color: 'warning' },
};

export const ORIGENES = {
  inscripcion: 'Inscrito en taller',
  matricula: 'Matrícula',
  cliente: 'Cuenta del portal',
};

export const PLANTILLAS = {
  aviso_general: { label: 'Aviso general', descripcion: 'Texto libre: novedades, recordatorios, campañas.' },
  operativa_taller: {
    label: 'Aviso de un taller',
    descripcion: 'Cambio de horario o lugar, suspensión o recordatorio. Destaca los datos clave arriba del texto.',
  },
};

export const MOTIVOS_DEFECTO = [
  { key: 'cambio_horario', label: 'Cambio de horario' },
  { key: 'cambio_lugar', label: 'Cambio de lugar' },
  { key: 'suspension', label: 'Suspensión de clase' },
  { key: 'recordatorio', label: 'Recordatorio' },
];

export const fechaHora = (v) =>
  v
    ? new Date(v).toLocaleString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : '—';
